import { v4 as uuidv4 } from 'uuid';

// centralized UUID generator
export function generate(): any {
    return uuidv4();
}
